export interface RankingItem {
  rank: number;
  title: string;
  heat: number;
  tag: string;
  trend: "up" | "down" | "new" | "flat";
}

export interface FeedCard {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  meta: string;
  heat: string;
  tag: string;
  image: string;
  width: number;
  height: number;
}

export interface CategoryItem {
  id: string;
  name: string;
  desc: string;
  count: string;
  icon: string;
  color: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  quote: string;
  name: string;
  role: string;
}

// 热搜瓜料榜单
export const hotRankings: RankingItem[] = [
  { rank: 1, title: "顶流演员塌房传闻再发酵，品牌方连夜解约", heat: 986, tag: "塌房", trend: "up" },
  { rank: 2, title: "新晋综艺黑马选手爆红，深扒其出道前经历", heat: 921, tag: "爆红", trend: "new" },
  { rank: 3, title: "知名导演新作被爆抄袭争议，主创团队回应", heat: 873, tag: "争议", trend: "up" },
  { rank: 4, title: "小花恋情实锤？同款行程被网友扒出细节", heat: 810, tag: "恋情", trend: "up" },
  { rank: 5, title: "老牌综艺回归，初代嘉宾阵容引集体回忆杀", heat: 765, tag: "综艺", trend: "flat" },
  { rank: 6, title: "歌手演唱会抢票难上热搜，黄牛乱象再引热议", heat: 702, tag: "演出", trend: "down" },
  { rank: 7, title: "某平台年度盛典名单曝光，红毯造型提前剧透", heat: 655, tag: "盛典", trend: "up" },
  { rank: 8, title: "顶流男团成员宣布单飞，粉丝反应两极分化", heat: 598, tag: "单飞", trend: "new" },
  { rank: 9, title: "热播剧续集官宣，原班人马能否再聚首成悬念", heat: 540, tag: "影视", trend: "flat" },
  { rank: 10, title: "主持人大意口误风波，节目组紧急发布说明", heat: 487, tag: "口误", trend: "down" },
];

// 大赏 / 精选 内容流
export const feedCards: FeedCard[] = [
  {
    id: "f1",
    category: "大赏",
    title: "年度热搜大赏：那些刷屏一整年的爆款瓜",
    excerpt: "从年初到年末，哪些事件真正牵动了全民情绪？我们用热度曲线还原这一年的吃瓜记忆，盘一盘那些霸榜热搜的高光时刻。",
    meta: "大赏编辑部 · 8分钟前",
    heat: "98.6万",
    tag: "年度盘点",
    image: "https://readdy.ai/api/search-image?query=editorial%20collage%20style%20illustration%20of%20glowing%20spotlight%20stage%20with%20scattered%20golden%20award%20trophies%2C%20warm%20cream%20background%2C%20coral%20red%20and%20melon%20green%20accent%20palette%2C%20bold%20flat%20graphic%20shapes%2C%20modern%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20no%20text&width=800&height=600&seq=hg-f1&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f2",
    category: "大赏",
    title: "综艺名场面大赏：十句台词被观众反复考古",
    excerpt: "有的镜头一眼封神，有的金句一火多年。今天带你重温那些被剪辑成梗、反复上热搜的综艺名场面，看看你还记得几个。",
    meta: "吃瓜前线 · 15分钟前",
    heat: "82.3万",
    tag: "综艺",
    image: "https://readdy.ai/api/search-image?query=modern%20flat%20editorial%20illustration%20of%20television%20studio%20with%20cameras%20and%20spotlights%2C%20speech%20bubble%20elements%20floating%2C%20cream%20and%20coral%20red%20palette%20with%20melon%20green%20accents%2C%20clean%20vector%20graphic%20composition%2C%20playful%20and%20vivid%2C%20no%20text&width=800&height=600&seq=hg-f2&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f3",
    category: "精选",
    title: "本月瓜料精选：五件值得反复细品的大事",
    excerpt: "编辑团队从海量讯息中挑出本月含金量最高的五件瓜，剔除噪音、还原脉络，让你用最短时间读懂背后的来龙去脉。",
    meta: "51黑瓜精选 · 26分钟前",
    heat: "76.1万",
    tag: "本月精选",
    image: "https://readdy.ai/api/search-image?query=hand%20drawn%20editorial%20illustration%20of%20a%20stack%20of%20newspaper%20pages%20with%20magnifying%20glass%2C%20warm%20cream%20backdrop%2C%20coral%20red%20melon%20green%20and%20mustard%20accents%2C%20minimal%20flat%20style%2C%20curated%20news%20theme%2C%20clean%20graphic%20layout%2C%20no%20text&width=800&height=600&seq=hg-f3&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f4",
    category: "精选",
    title: "盘点与精选联动：近期口碑逆袭的冷门佳作",
    excerpt: "有些作品初看平平，后劲却十足。我们联合盘点栏目，找出近期被观众自发安利、口碑一路逆袭的几部冷门佳作。",
    meta: "51黑瓜精选 · 38分钟前",
    heat: "69.4万",
    tag: "口碑",
    image: "https://readdy.ai/api/search-image?query=stylish%20editorial%20illustration%20of%20film%20clapperboard%20and%20ticket%20stubs%20with%20rising%20arrow%2C%20cream%20background%2C%20coral%20melon%20green%20and%20amber%20flat%20graphic%20palette%2C%20minimal%20modern%20collage%2C%20no%20text&width=800&height=600&seq=hg-f4&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f5",
    category: "盘点",
    title: "一周瓜料盘点：三天爆出的大瓜你都吃到了吗",
    excerpt: "短短一周信息量爆棚，从代言解约到行程撞车，本期盘点带你逐条梳理本周最重磅的几条瓜料，不错过任何细节。",
    meta: "盘点工坊 · 1小时前",
    heat: "61.8万",
    tag: "一周盘点",
    image: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20a%20calendar%20and%20clock%20with%20bursting%20news%20elements%2C%20warm%20cream%20background%2C%20coral%20red%2C%20melon%20green%2C%20mustard%20color%20blocks%2C%20weekly%20review%20concept%2C%20clean%20vector%20style%2C%20no%20text&width=800&height=600&seq=hg-f5&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f6",
    category: "盘点",
    title: "年度现象级盘点：全民参与的那些舆论事件",
    excerpt: "这一年有哪些事件真正跨越圈层、引发全民讨论？从传播路径到情绪走向，我们还原现象背后的深层逻辑。",
    meta: "盘点工坊 · 2小时前",
    heat: "57.2万",
    tag: "年度",
    image: "https://readdy.ai/api/search-image?query=dynamic%20flat%20illustration%20of%20network%20connections%20and%20speech%20bubbles%20forming%20a%20web%2C%20cream%20background%2C%20coral%20red%20and%20melon%20green%20nodes%2C%20viral%20trend%20concept%2C%20modern%20editorial%20graphic%2C%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=hg-f6&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f7",
    category: "大赏",
    title: "红毯造型大赏：谁才是年度最佳衣品担当",
    excerpt: "聚光灯下的每一次亮相都暗藏玄机。我们按场合、创意与话题度综合评选，看看过去一年哪些红毯造型真正出圈。",
    meta: "大赏编辑部 · 3小时前",
    heat: "51.9万",
    tag: "红毯",
    image: "https://readdy.ai/api/search-image?query=glamorous%20flat%20editorial%20illustration%20of%20red%20carpet%20with%20elegant%20silhouette%20and%20camera%20flash%20sparkles%2C%20cream%20and%20coral%20red%20palette%2C%20melon%20green%20accents%2C%20fashion%20award%20theme%2C%20clean%20vector%20composition%2C%20no%20text&width=800&height=600&seq=hg-f7&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f8",
    category: "精选",
    title: "编辑部精选：被严重低估的五段采访对话",
    excerpt: "比起爆点热搜，有些深入的采访更值得被看见。本期精选五段信息量充足、诚意满满的对话，带你看见故事的另一面。",
    meta: "51黑瓜精选 · 4小时前",
    heat: "46.3万",
    tag: "采访",
    image: "https://readdy.ai/api/search-image?query=flat%20editorial%20illustration%20of%20two%20microphones%20and%20sound%20wave%20lines%20on%20warm%20cream%20background%2C%20coral%20red%2C%20melon%20green%20and%20amber%20accents%2C%20interview%20concept%2C%20minimal%20modern%20collage%2C%20no%20text&width=800&height=600&seq=hg-f8&orientation=landscape",
    width: 800,
    height: 600,
  },
  {
    id: "f9",
    category: "盘点",
    title: "瓜料源头大盘点：热梗背后的传播密码",
    excerpt: "同样一件事，为何有的迅速出圈、有的石沉大海？我们从源头到二次创作拆解传播链路，看看热梗背后的共通规律。",
    meta: "盘点工坊 · 5小时前",
    heat: "39.7万",
    tag: "传播",
    image: "https://readdy.ai/api/search-image?query=creative%20flat%20illustration%20of%20mega%20horn%20and%20echo%20waves%20spreading%20outward%20with%20small%20stars%2C%20cream%20background%2C%20coral%20red%20and%20melon%20green%20palette%2C%20viral%20spread%20concept%2C%20clean%20editorial%20vector%20style%2C%20no%20text&width=800&height=600&seq=hg-f9&orientation=landscape",
    width: 800,
    height: 600,
  },
];

// 频道分类
export const categories: CategoryItem[] = [
  { id: "c1", name: "明星动态", desc: "行程、营业与最新近况", count: "2.3k条", icon: "ri-star-line", color: "bg-primary-500" },
  { id: "c2", name: "影视热评", desc: "剧集综艺与口碑追踪", count: "1.8k条", icon: "ri-film-line", color: "bg-accent-500" },
  { id: "c3", name: "榜单排行", desc: "人气、热度与话题榜", count: "1.5k条", icon: "ri-trophy-line", color: "bg-secondary-500" },
  { id: "c4", name: "圈内观察", desc: "行业动向与幕后解读", count: "980条", icon: "ri-eye-line", color: "bg-primary-500" },
  { id: "c5", name: "吃瓜速报", desc: "第一时间的即时瓜料", count: "3.1k条", icon: "ri-flashlight-line", color: "bg-accent-500" },
  { id: "c6", name: "深度专题", desc: "有来龙去脉的完整故事", count: "760条", icon: "ri-file-search-line", color: "bg-secondary-500" },
];

// 常见问题
export const faqs: FaqItem[] = [
  {
    q: "51黑瓜与其他吃瓜平台有什么不同？",
    a: "51黑瓜把海量碎片信息整理成大赏、精选、盘点与榜单四个板块。我们不只追热点，更帮你厘清事件脉络、补充背景信息，让每条瓜都有来龙去脉，阅读更省时、更清晰。",
  },
  {
    q: "大赏、精选、盘点这几个栏目分别是什么意思？",
    a: "大赏侧重视觉与表现力的高光时刻，精选由编辑部人工甄选高含金量内容，盘点则按周、月、年等周期系统梳理某一时段的重要事件，方便你回顾和追进度。",
  },
  {
    q: "内容多久更新一次？",
    a: "吃瓜速报类内容实时跟进，尽可能第一时间跟进最新动态；大赏、精选与盘点栏目则由编辑部策划，通常每周多次更新，确保信息既有速度也有质量。",
  },
  {
    q: "我能在这里参与讨论或投稿吗？",
    a: "当然可以。每篇内容下方都支持交流，我们也欢迎读者投稿有意思的素材或线索。编辑部会核实信息后择优整理发布，优质内容会进入精选栏目。",
  },
  {
    q: "信息是否经过核实？",
    a: "我们坚持信息来源可追溯的原则，转载与引用都会标注出处，避免传播未经证实的消息。涉及重大争议的内容会保留说明，等待官方信息进一步确认。",
  },
  {
    q: "如何联系51黑瓜编辑部？",
    a: "你可以通过页脚提供的联系邮箱与我们沟通，也可以在相关内容下留言。编辑部会定期查看消息，合作、反馈与线索投稿都可以通过这些渠道找到我们。",
  },
];

// 用户口碑
export const testimonials: Testimonial[] = [
  {
    quote: "把零散的瓜整理成有脉络的盘点，太省心了。现在每天睡前刷一遍精选和榜单就够了。",
    name: "爱看热闹的小王",
    role: "三年老粉",
  },
  {
    quote: "大赏栏目是我最喜欢看的，很多高光瞬间平时根本刷不到，整理得非常用心。",
    name: "追剧狂魔",
    role: "影视爱好者",
  },
  {
    quote: "信息标注清楚来源，不会为了流量乱带节奏，这点在瓜圈真的很难得。",
    name: "资深吃瓜人",
    role: "内容研究者",
  },
];

// 品牌 / 栏目导航
export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "热点榜单", href: "#rank" },
  { label: "大赏精选", href: "#featured" },
  { label: "频道分类", href: "#categories" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];